import { createBrowserRouter, Outlet, useLoaderData } from "react-router-dom";
import Home from "./Home/Home";
import Chat from "./Chat/Chat";
import { OAUTH_URL, API_URL, SOCKET_URL } from "../helpers/variables";
import { io } from "socket.io-client";
import Rooms from "./Rooms/Rooms";

async function checkRoom(roomID) {
  let res = await fetch(`${API_URL}/check_room?room_id=${roomID}`);
  let status = res.status;
  if (status === 200) {
    let data = await res.text();
    return JSON.parse(data);
  } else if (status === 404) {
    throw new Error(`Room not found (status: ${status})`);
  } else {
    throw new Error(`Unexpected error (status: ${status})`);
  }
}

async function checkUser(room, userID) {
  let participants = room["participants"] || [];
  let user = participants.find((i) => !i["removed"] && i["userID"] === userID);
  if (!user) {
    throw new Error(`User Not found`);
  }
  return user;
}

async function getRooms(userID) {
  let res = await fetch(`${API_URL}/get_rooms?user_id=${userID}`);
  let status = res.status;
  if (status === 200) {
    let data = await res.text();
    return JSON.parse(data);
  } else if (status === 404) {
    throw new Error(`Rooms not found (status: ${status})`);
  } else {
    console.log("Error", res.statusText);
    throw new Error(`Unexpected error (status: ${status})`);
  }
}

function Authenticate() {
  const { authID } = useLoaderData();
  return <Outlet context={{ authID }} />;
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    element: <Authenticate />,
    loader: async ({ request }) => {
      const url = new URL(request.url);
      return "removed"
      
    },
    children: [
      {
        path: "rooms",
        loader: async ({ request }) => {
          const url = new URL(request.url);
          const userID = url.searchParams.get("userID");
          if (!userID) {
            throw new Error("Missing required parameters.");
          }
          const rooms = await getRooms(userID);
          return { userID, rooms };
        },
        element: <Rooms />,
      },
      {
        path: "chat",
        loader: async ({ request }) => {
          const url = new URL(request.url);
          const authID = url.searchParams.get("authID");
          const roomID = url.searchParams.get("roomID");
          const userID = url.searchParams.get("userID");
          const chatStatus = url.searchParams.get("chatStatus");

          if (!roomID || !userID) {
            throw new Error("Missing required parameters.");
          }

          //Todo reduce to one call CheckCredentials
          let room = await checkRoom(roomID);
          let user = await checkUser(room, userID);

          const socket = io(SOCKET_URL, {
            path: "/socket.io/",
            query: { userID },
          });
          socket.emit("joinRoom", roomID);

          return { socket, room, user, chatStatus, authID };
        },
        element: <Chat />,
      },
    ],
  },
]);

export default router;
